export default "22fdacf1c10b66a2.png"